import { axiosRef } from '../../../api';
import { formatDateWithDashes } from '../../../utils/helper';
import { TrackingReportPayload } from '../interfaces';

export default async function getTrackingReport(
  payload: TrackingReportPayload,
  isAdmin: boolean,
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  let url = `${isAdmin ? '/admin' : ''}/reports/tracking?`;

  if (payload && payload.startDate && payload.endDate) {
    const start = formatDateWithDashes(payload.startDate);
    const end = formatDateWithDashes(payload.endDate);
    url += `start_date=${start}&end_date=${end}&`;
  }

  if (isAdmin && payload && payload.account) {
    url = url + `&account=${payload.account}`;
  }

  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const report = response.data.content;
      return {
        report,
      };
    }
    setLoading(false);
    return {
      report: null,
    };
  } catch (error) {
    setLoading(false);
    return {
      report: null,
    };
  }
}
